module.exports = __webpack_public_path__ + "media/Images/tpa-faq-image4-fce59f5af5f90b0e6f79375bef6095fb.jpg";